import { render } from "./BaseInput2.vue?vue&type=template&id=ce65b400&scoped=true"
import script from "./BaseInput2.vue?vue&type=script&lang=js"
export * from "./BaseInput2.vue?vue&type=script&lang=js"

import "./BaseInput2.vue?vue&type=style&index=0&id=ce65b400&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce65b400"]])

export default __exports__